import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  name: 'production',
  production: true,
  apiUrl: 'https://api.bath-dream.ru',
  messengerUrl: 'https://messenger.bath-dream.ru',
  cookieDomain: '.bath-dream.ru',
  orderPageIconBasePath: '/assets/img/allwork',
};
